import React from "react";
import { Header as TableHeadings, Rows as TableRows } from "./table";
import Checkbox from "src/scenes/EmployeeList/components/Checkbox";
import { useQuotesTableHooks } from "./hooks/useQuotesTableHooks";
import { ActivateFeatureButton, DataTable, DataTableContainer, FlexContainer, PortalSearchInput, PortalTableActions, PortalTableControls, UpperControls } from "src/components";
import { DeleteButtons } from "./style";

export const MyQuotesTable = (props) => {
    const { data, manageQuotes, setQuotesFromParent } = props;
    const {
        quotes,
        selectedQuotes,
        selectAllQuotes,
        handleSearchQuotes,
        handleMainCheckbox,
        toggleQuoteSelection,
        isQuoteSelected,
        handleSortColumn,
        handleDeleteSelectedQuotes,
    } = useQuotesTableHooks(data, setQuotesFromParent);

    const headings = [
        <Checkbox
            checked={selectAllQuotes}
            onChange={() => handleMainCheckbox()}
            onClick={e => e.stopPropagation()} 
        />,
        "Quote Image", "Quote Text",
        "Article Image", "Article Title",
        "Article Description", "View/Edit"
    ];

    const isASortableColumn = (index) => index > 0;

    return (
        <FlexContainer>
            <UpperControls>
                <PortalTableControls>
                    <PortalSearchInput placeholder="Search quote" type="text" onChange={(e) => handleSearchQuotes(e)} />
                    {(selectedQuotes.length > 0) && (
                        <DeleteButtons
                            onClick={() => handleDeleteSelectedQuotes()}>
                            Delete Quote
                        </DeleteButtons>
                    )}
                </PortalTableControls>
                <PortalTableActions>
                    <ActivateFeatureButton
                        width="184px"
                        height="39px"
                        onClick={() => manageQuotes.createQuotes()}
                    >
                        Add Quote
                    </ActivateFeatureButton>
                </PortalTableActions>
            </UpperControls>
            <DataTableContainer>
                <DataTable minWidth="980px">
                    <thead>
                        <TableHeadings
                            headings={headings}
                            onSort={handleSortColumn}
                            onMainCheck={handleMainCheckbox}
                            isSortable={isASortableColumn}
                        />
                    </thead>
                    <tbody>
                        <TableRows
                            quotes={quotes}
                            onToggle={(quote) => toggleQuoteSelection(quote)}
                            isSelected={isQuoteSelected}
                            manageQuotes={manageQuotes}
                        />
                    </tbody>
                </DataTable>
            </DataTableContainer>
        </FlexContainer>
    );
};
